export default {
    name: 'inspiration',
    props: {
        type: { default: 'inspiration', type: String },
        zoom: { default: false, type: Boolean },
        selected: { default: null }
    },
    data() {
        return {
            products: [],
            productMap: {},
            selectedProduct: 'all',
            styles: [],
            favourites: []
        }
    },
    computed: {
        hasFavourites: function() {
            // return this.favourites.length > 0;
            return this.favouritesStyles.length > 0;
        },
        productStyles() {
            if (this.selectedProduct == 'all') {
                return this.styles;
            }
            return this.styles.filter((style) => {
                return style.product_id == this.selectedProduct
            })
        },
        stylesWithoutFavourites() {
            return this.productStyles.filter((style) => {
                return this.favourites.indexOf(style.id) == -1
            });
        },
        favouritesStyles() {
            return this.productStyles.filter((style) => {
                return this.favourites.indexOf(style.id) != -1
            });
        },
        styleGroups: function() {
            var groups = [];
            for (var i = 0; i < this.stylesWithoutFavourites.length; i += 6) {
                groups.push(this.stylesWithoutFavourites.slice(i, i + 6));
            }
            return groups;
        },
        favouriteGroups() {
            var groups = [];
            for (var i = 0; i < this.favouritesStyles.length; i += 6) {
                groups.push(this.favouritesStyles.slice(i, i + 6));
            }
            return groups;
        },
        productOptions() {
            var options = [{ value: 'all', text: 'All' }];
            // console.log('products', this.products);
            this.products.forEach((product) => {
                options.push({ value: product.id, text: product.name })
            })
            return options;
        }
    },
    methods: {
        close(modalId) {
            this.$root.$emit('bv::hide::modal', modalId)
        },
        logo(id) {
            return 'https://services.propertylogic.net/images/pom/' + id + '.jpg';
        },
        fetch() {
            // fetch the products
            this.axios.get('/api/product').then((response) => {
                // console.log('products response', response);
                this.products = response.data;
                this.products.forEach((product) => {
                    this.productMap[product.id] = product
                });
                // this.selectedProduct = this.products[0].id
            }).catch((error) => {
                console.log(error);
            });

            // fetch the designs
            this.axios.get('/api/design').then((response) => {
                // console.log(response);
                this.styles = response.data;
            }).catch((error) => {
                console.log(error);
            });

            // fetch the liked designs
            this.axios.get('/api/design-like').then((response) => {
                // console.log(response);
                this.favourites = response.data.likes;
                if (this.selected) {
                    this.selectedProduct = this.selected;
                } else {
                    this.selectedProduct = response.data.fav_product;
                }
            }).catch((error) => {
                console.log(error);
            });
        },
        like(id) {
            this.favourites.push(id);
            this.axios.post('/api/design-like/add', {
                design_id: id
            }).then((response) => {
                // console.log(response)
            }).catch((error) => {
                console.log(error);
            });
        },
        unlike(id) {
            this.favourites.splice(this.favourites.indexOf(id), 1);
            this.axios.post('/api/design-like/remove', {
                design_id: id
            }).then((response) => {
                // console.log(response)
            }).catch((error) => {
                console.log(error);
            });
        },
        select(style) {
            this.$root.$emit('design::selected', style)
            this.$root.$emit('bv::hide::modal', 'inspiration')
        }
    },
    mounted() {
        this.fetch();
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/inspiration/inspiration.js